/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { OrderIdFromHostedCheckoutIdRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { OrderIdFromHostedCheckoutIdResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * OrderIdFromHostedCheckoutIdApi - axios parameter creator
 * @export
 */
export const OrderIdFromHostedCheckoutIdApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This fetches order ID and order status from from hosted checkout ID and to confirm whether to call precheckout and checkout or not
         * @summary This fetches order ID and order status from from hosted checkout ID and to confirm whether to call precheckout and checkout or not
         * @param {string} storeId The store identifier.
         * @param {OrderIdFromHostedCheckoutIdRequest} orderIdFromHostedCheckoutIdRequest The request object for verifying order status and fetch orderId through hostedCheckoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderIdFromHostedCheckoutId: async (storeId: string, orderIdFromHostedCheckoutIdRequest: OrderIdFromHostedCheckoutIdRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('orderIdFromHostedCheckoutId', 'storeId', storeId)
            // verify required parameter 'orderIdFromHostedCheckoutIdRequest' is not null or undefined
            assertParamExists('orderIdFromHostedCheckoutId', 'orderIdFromHostedCheckoutIdRequest', orderIdFromHostedCheckoutIdRequest)
            const localVarPath = `/store/{storeId}/resources/payment/getOrderIdFromHostedCheckoutId`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderIdFromHostedCheckoutIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderIdFromHostedCheckoutIdApi - functional programming interface
 * @export
 */
export const OrderIdFromHostedCheckoutIdApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderIdFromHostedCheckoutIdApiAxiosParamCreator(configuration)
    return {
        /**
         * This fetches order ID and order status from from hosted checkout ID and to confirm whether to call precheckout and checkout or not
         * @summary This fetches order ID and order status from from hosted checkout ID and to confirm whether to call precheckout and checkout or not
         * @param {string} storeId The store identifier.
         * @param {OrderIdFromHostedCheckoutIdRequest} orderIdFromHostedCheckoutIdRequest The request object for verifying order status and fetch orderId through hostedCheckoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderIdFromHostedCheckoutId(storeId: string, orderIdFromHostedCheckoutIdRequest: OrderIdFromHostedCheckoutIdRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderIdFromHostedCheckoutIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderIdFromHostedCheckoutId(storeId, orderIdFromHostedCheckoutIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderIdFromHostedCheckoutIdApi - factory interface
 * @export
 */
export const OrderIdFromHostedCheckoutIdApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderIdFromHostedCheckoutIdApiFp(configuration)
    return {
        /**
         * This fetches order ID and order status from from hosted checkout ID and to confirm whether to call precheckout and checkout or not
         * @summary This fetches order ID and order status from from hosted checkout ID and to confirm whether to call precheckout and checkout or not
         * @param {string} storeId The store identifier.
         * @param {OrderIdFromHostedCheckoutIdRequest} orderIdFromHostedCheckoutIdRequest The request object for verifying order status and fetch orderId through hostedCheckoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderIdFromHostedCheckoutId(storeId: string, orderIdFromHostedCheckoutIdRequest: OrderIdFromHostedCheckoutIdRequest, options?: any): AxiosPromise<OrderIdFromHostedCheckoutIdResponse> {
            return localVarFp.orderIdFromHostedCheckoutId(storeId, orderIdFromHostedCheckoutIdRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderIdFromHostedCheckoutIdApi - object-oriented interface
 * @export
 * @class OrderIdFromHostedCheckoutIdApi
 * @extends {BaseAPI}
 */
export class OrderIdFromHostedCheckoutIdApi extends BaseAPI {
    /**
     * This fetches order ID and order status from from hosted checkout ID and to confirm whether to call precheckout and checkout or not
     * @summary This fetches order ID and order status from from hosted checkout ID and to confirm whether to call precheckout and checkout or not
     * @param {string} storeId The store identifier.
     * @param {OrderIdFromHostedCheckoutIdRequest} orderIdFromHostedCheckoutIdRequest The request object for verifying order status and fetch orderId through hostedCheckoutId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderIdFromHostedCheckoutIdApi
     */
    public orderIdFromHostedCheckoutId(storeId: string, orderIdFromHostedCheckoutIdRequest: OrderIdFromHostedCheckoutIdRequest, options?: any) {
        return OrderIdFromHostedCheckoutIdApiFp(this.configuration).orderIdFromHostedCheckoutId(storeId, orderIdFromHostedCheckoutIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
